import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Breadcrumb from '@/components/base/Breadcrumb';
import { articles } from '@/mocks/articles';

export default function Articles() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="flex flex-col min-h-screen">
      <main>
        <section className="pt-24 pb-10 md:pt-32 md:pb-14 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="mb-6">
              <Breadcrumb items={[
                { label: '首页', path: '/' },
                { label: '行业洞察' },
              ]} />
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950 mb-4">
              行业洞察
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl font-body">
              btbxx行业专家团队深度洞察，为您解读行业趋势、分享产品动态、剖析实战案例
            </p>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6">
            <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-1 flex-wrap">
              <button className="px-4 py-2 rounded-full text-sm font-label font-medium bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer">
                全部文章
              </button>
              <button className="px-4 py-2 rounded-full text-sm font-label font-medium bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                行业洞察
              </button>
              <button className="px-4 py-2 rounded-full text-sm font-label font-medium bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                产品功能
              </button>
              <button className="px-4 py-2 rounded-full text-sm font-label font-medium bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                案例分析
              </button>
              <button className="px-4 py-2 rounded-full text-sm font-label font-medium bg-background-100 text-foreground-700 hover:bg-background-200 transition-colors duration-200 whitespace-nowrap cursor-pointer">
                技术前沿
              </button>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.id}`}
                  className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200/60 transition-all duration-300 block"
                >
                  <div className="relative h-48 md:h-56 overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      title={article.title}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                    <div className="absolute top-3 left-3">
                      <span className="px-3 py-1 rounded-full bg-background-50/90 backdrop-blur-sm text-xs font-label font-medium text-foreground-700">
                        {article.category}
                      </span>
                    </div>
                  </div>

                  <div className="p-5 md:p-6">
                    <div className="flex items-center gap-4 text-xs text-foreground-500 font-label mb-3">
                      <span>{article.date}</span>
                      <span className="w-1 h-1 rounded-full bg-foreground-400"></span>
                      <span>{article.readTime}阅读</span>
                    </div>

                    <h2 className="font-heading text-lg md:text-xl font-semibold text-foreground-950 mb-3 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h2>

                    <p className="text-sm text-foreground-600 leading-relaxed line-clamp-2 mb-4 font-body">
                      {article.excerpt}
                    </p>

                    <div className="flex items-center gap-2 flex-wrap">
                      {article.tags.slice(0, 3).map((tag) => (
                        <span
                          key={tag}
                          className="px-2.5 py-1 rounded-full bg-background-100 text-xs font-label text-foreground-600"
                        >
                          {tag}
                        </span>
                      ))}
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="w-full max-w-7xl mx-auto px-4 md:px-6 text-center">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
              持续关注 btbxx 行业洞察
            </h2>
            <p className="text-sm text-foreground-600 mb-8 font-body max-w-xl mx-auto">
              订阅我们的内容更新，第一时间获取行业深度洞察和btbxx产品动态
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto">
              <input
                type="email"
                placeholder="请输入您的邮箱地址"
                className="w-full px-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors font-body"
              />
              <button className="w-full sm:w-auto px-6 py-2.5 rounded-md bg-primary-500 text-background-50 font-label font-semibold text-sm hover:bg-primary-600 transition-all duration-200 whitespace-nowrap cursor-pointer">
                订阅更新
              </button>
            </div>
          </div>
        </section>
      </main>

      <script type="application/ld+json">{JSON.stringify({
        '@context': 'https://schema.org',
        '@type': 'WebPage',
        name: 'btbxx行业洞察 - 企业数字化转型文章',
        description: 'btbxx行业专家团队深度洞察，为您解读行业趋势、分享产品动态、剖析实战案例。关注数字化转型、企业服务、数据智能等热门话题。',
        url: 'https://www.btbxx.com/articles',
        isPartOf: { '@type': 'WebSite', name: 'btbxx', url: 'https://www.btbxx.com/' },
      })}</script>
    </div>
  );
}